import { render, staticRenderFns } from "./MedicationPlanDelete.vue?vue&type=template&id=1ba27075&scoped=true&"
import script from "./MedicationPlanDelete.vue?vue&type=script&lang=js&"
export * from "./MedicationPlanDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba27075",
  null
  
)

export default component.exports